import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97a3e30c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "rate flex-ter rel"
}
const _hoisted_3 = { style: {"max-width":"264px","font-size":"14px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ： ")
const _hoisted_5 = { class: "rel flex-ter" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "%", -1))
const _hoisted_7 = { class: "abs tip" }

import QuestionMark from '@/components/IconPark/QuestionMark.vue'
import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import { purchaseCfg, purchaseUpt } from '@/apis/setup'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  async setup(__props) {

let __temp: any, __restore: any

const { purchasePriceAdd } = (
  ([__temp,__restore] = _withAsyncContext(() => purchaseCfg().then((res) => res?.data ?? {}))),
  __temp = await __temp,
  __restore(),
  __temp
)

const percent = ref(purchasePriceAdd ?? 0)

const updateRate = () => {
  purchaseUpt({ purchasePriceAdd: percent.value }).then((res) => {
    if (res.success) {
      ElMessage.success(t('修改成功'))
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(purchasePriceAdd) === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", null, [
            _createTextVNode(_toDisplayString(_unref(t)('价格浮动百分比')) + " ", 1),
            _createVNode(_component_el_tooltip, {
              effect: "light",
              placement: "top",
              "popper-class": "tool-tip-no-border"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('此设置只针对代采商品生效')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(QuestionMark, {
                  size: 14,
                  color: "#333",
                  class: "cursor-pt",
                  style: {"vertical-align":"text-top","margin-top":"3px"}
                })
              ]),
              _: 1
            }),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_input_number, {
              min: 0,
              max: 1000,
              controls: false,
              modelValue: percent.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((percent).value = $event)),
              onChange: updateRate
            }, null, 8, ["modelValue"]),
            _hoisted_6
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)(
          '原有的商品缺货时，我们会帮你查找新的采购链接，所以请告诉我您能接受的采购价格区间变动'
        )), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})